import axios from "axios";
import { SIGN_IN_VISITOR } from "./types";
import { useTranslation } from "react-i18next";

export const checkValidParkingZone =
  (parkingZone, openNotExistParkingZoneModal, setParkingZone, closeModal) =>
  async () => {
    axios
      .get(
        `${
          process.env.REACT_APP_SERVICE_URL
        }/api/parking-zone/parkingZoneNumber/${parkingZone.replaceAll(" ", "")}`
      )
      .then((response) => {
        if (response.status === 404) {
          openNotExistParkingZoneModal("PZ_NOT_EXIST");
        } else if (response.status === 403){
          openNotExistParkingZoneModal("VISITOR_NOT_ALLOWED");
        } else {
          setParkingZone(response.data);
          closeModal();
        }
      });
  };

export const checkDailyCodeInParkingZone =
  (dailyCode, openWrongDailyCode, history) => async (dispatch) => {
    axios
      .put(
        `${process.env.REACT_APP_SERVICE_URL}/api/parking-zone/checkDailyCodeVisitor`,
        dailyCode
      )
      .then((response) => {
        if (response.status === 400) {
          openWrongDailyCode();
        } else {
          dispatch({
            type: SIGN_IN_VISITOR,
            payload: response.data,
          });
          history.push({
            pathname: "/legalVisitor",
          });
        }
      });
  };
